export const environment = {
  production: false,
  apiBaseUrl: 'https://acs.proxy-beta.modulr.fr',
  apiEnv: '',
  apiBase: '',
  useFakeHttp: false
};
